import _ from 'lodash';

import { Typography } from 'omakase';
import BaseComponent from '@tock/shared/components/BaseComponent';
import NewlineEscapedText from '@tock/shared/components/NewlineEscapedText';

interface Props {
  answer: string[];
  question: string;
}

class FaqItem extends BaseComponent<Props> {
  render() {
    const { answer, question } = this.props;

    return (
      <div className="Faqs-item">
        <h4 className="Faqs-itemHeading">
          <Typography color="inherit" component="span" variant="heading04">
            {question}
          </Typography>
        </h4>
        {_.map(answer, (paragraph, idx) => (
          <p className="Faqs-itemContent" key={idx}>
            <Typography color="inherit" component="span" variant="body02">
              <NewlineEscapedText text={paragraph} />
            </Typography>
          </p>
        ))}
      </div>
    );
  }
}

export default FaqItem;
